/**
 * 全局常量配置
 * 使用构建时注入的 OEM 配置，无需运行时域名判断
 */

import { buildCopyrightTagline } from "./siteFooter";

// 从构建时注入的环境变量获取 OEM 配置
// 这些值在构建时由 vite.config.ts 根据 OEM_NAME 注入
const getOemConfig = () => {
  return {
    appName: import.meta.env.VITE_OEM_PLATFORM_NAME || "Lychee Voice",
    logo: import.meta.env.VITE_OEM_LOGO || "/marketing-assets/brand-logo.png",
    appDescription: import.meta.env.VITE_OEM_APP_DESCRIPTION || "媲美科技智能语音平台",
  };
};

const oemConfig = getOemConfig();

// 应用名称（从 OEM 配置获取）
export const APP_NAME = oemConfig.appName;

// 应用完整描述（从 OEM 配置获取）
export const APP_DESCRIPTION = oemConfig.appDescription;

// 单行产品版权（统一由 siteFooter 生成，年份随当前年）
export const COPYRIGHT_TEXT = buildCopyrightTagline(oemConfig.appName);

// Logo图片地址（从 OEM 配置获取）
export const LycheeVoice_LOGO = oemConfig.logo;

/**
 * 宣传落地页静态资源目录（对应 `public/marketing-assets/`）。
 * 勿使用 `/marketing/` 作为静态前缀，否则与 SPA 路由 `/home`（原 `/marketing`）冲突，刷新 `/home` 会命中目录返回 403。
 */
export const MARKETING_STATIC_ASSETS_BASE = "/marketing-assets";

/** 浏览器标签页 favicon / apple-touch-icon / manifest，与宣传页 `brand-logo.png` 一致 */
export const TAB_BRAND_ICON = `${MARKETING_STATIC_ASSETS_BASE}/brand-logo.png`;

import { API_DOC_PAGE_PATH } from "../utils/menuPathNormalize";

/**
 * 开放平台 API 文档页（站内路由，不再外链飞书）。
 * 与 `HomeShell` 侧栏、营销页「开放能力 / API 文档」入口一致。
 */
export const API_DOCUMENTATION_URL = API_DOC_PAGE_PATH;

/** 一键速译、精品译制等单次会话内视频总集数上限（含多批选择） */
export const MAX_UPLOAD_VIDEO_EPISODES = 80;

